import React, { useEffect, useState } from 'react';
import { getActiveInvoiceDeductions } from '../../helper/Utils';

const CHIP_GAP = 4;

const chipStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '11px',
    padding: '2px 6px',
    borderRadius: '4px',
    backgroundColor: '#f3f4f6',
    color: '#374151',
    whiteSpace: 'nowrap',
};

export default function PpaDeductionDetailsCell({ row }) {
    const [, setAmountFormatTick] = useState(0);

    useEffect(() => {
        const onAmountDivisorChange = () => setAmountFormatTick((tick) => tick + 1);
        window.addEventListener('amount_divisor_changed', onAmountDivisorChange);
        return () => window.removeEventListener('amount_divisor_changed', onAmountDivisorChange);
    }, []);

    const deductionItems = getActiveInvoiceDeductions(
        row?.invoice_deduction_details,
        row
    );

    if (!deductionItems.length) {
        return (
            <span style={{ color: '#9ca3af', fontSize: '12px' }}>No deduction</span>
        );
    }

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: `${CHIP_GAP}px`,
                lineHeight: 1.25,
            }}
        >
            {deductionItems.map(({ key, label, amount }) => (
                <span key={key} style={chipStyle}>
                    <span style={{ color: '#6b7280', fontWeight: 500 }}>{label}</span>
                    <span style={{ fontWeight: 600 }}>{amount}</span>
                </span>
            ))}
        </div>
    );
}
